
import { AnyObject } from "immer/dist/internal";
import { BlockPeriodClass } from "./block-period.class";
import { IMealTime } from "src/app/models/meal-plans/meal-time.interface";
import { _DEFAULT_NUTRITIONAL_PROPERTIES, IFoodGroupIngredient, INutritionalProperties } from "src/app/models/food-group";
import { BlockPeriodDTO } from "src/app/dtos/meal-plan";
import { IIngredient } from "src/app/models/ingredient";
import { cloneDeep } from "lodash";

export class MealTimeClass {
    _id: string;
    planPeriodId: string;
    title: string;
    hasHour: boolean;
    time: { hour: number, minute: number };
    datetime: Date;
    metadata: AnyObject = {
        distribution: {},
        nutrientTable: {}
    };
    blockPeriods: BlockPeriodClass[];
    hasError: boolean;
    editMode: boolean;
    valid: boolean;
    modeReadOnly: boolean;
    nutritionalProperties: INutritionalProperties;
    isNew: boolean;
    index: number;



    constructor(mealTime?: IMealTime, blockPeriods?: BlockPeriodClass[]) {
        this._id = mealTime?._id || null;
        this.planPeriodId = mealTime?.planPeriodId || '';
        this.title = mealTime?.title || '';
        this.metadata = mealTime?.metadata || {
            distribution: {},
            nutrientTable: {}
        };
        this.blockPeriods = blockPeriods || [];
        this.hasHour = mealTime?.hasHour ?? false;
        this.time = mealTime?.time ?? { hour: null, minute: null };
        this.datetime = mealTime?.datetime ?? null;
        this.index = mealTime?.index ?? 0;
        this.valid = false;
        this.hasError = false;
        this.editMode = false;
        this.modeReadOnly = false;
        this.syncNutritionalProperties();
    }

    public syncNutritionalProperties(): void {
        console.log('HOLA?');
        this.nutritionalProperties = cloneDeep(_DEFAULT_NUTRITIONAL_PROPERTIES);
        this.blockPeriods.forEach((blockPeriod: BlockPeriodClass) => {
            for (const p in blockPeriod.nutritionalProperties) {
                if (blockPeriod.nutritionalProperties.hasOwnProperty(p)) {
                    this.nutritionalProperties[p] += +blockPeriod.nutritionalProperties[p];
                }
            }
        });
    }

    public setIndex(index: number): void {
        this.index = index;
    }

    public getIndex(): number {
        return this.index;
    }

    public setIsNew(isNew: boolean): void {
        this.isNew = isNew;
    }

    public getIsNew(): boolean {
        return this.isNew;
    }

    public setId(id: string): void {
        this._id = id;
    }

    public setTitle(title: string): void {
        this.title = title;
    }

    public setPlanPeriodId(planPeriodId: string): void {
        this.planPeriodId = planPeriodId;
    }

    public setBlockPeriods(blockPeriods: BlockPeriodClass[]): void {
        this.blockPeriods = blockPeriods;
    }

    public setHasHour(hasHour: boolean): void {
        this.hasHour = hasHour;
    }

    public setTime(time: { hour: number, minute: number }): void {
        this.time = time;
    }

    public setMetadata(metadata: AnyObject): void {
        this.metadata = metadata;
    }

    public setDatetime(value: Date): void {
        this.datetime = value;
    }

    public setNutritionalProperties(nutritionalProperties: INutritionalProperties): void {
        this.nutritionalProperties = nutritionalProperties;
    }

    public setEditMode(editMode: boolean): void {
        this.editMode = editMode;
    }

    public setModeReadOnly(modeReadOnly: boolean): void {
        this.modeReadOnly = modeReadOnly;
    }

    public setValid(valid: boolean): void {
        this.valid = valid;
    }

    public setHasError(hasError: boolean): void {
        this.hasError = hasError;
    }

    public getId(): string {
        return this._id;
    }

    public getPlanPeriodId(): string {
        return this.planPeriodId;
    }

    public getTitle(): string {
        return this.title;
    }

    public getDatetime(): Date {
        return this.datetime;
    }

    public getBlockPeriods(): BlockPeriodClass[] {
        return this.blockPeriods;
    }

    public getHasHour(): boolean {
        return this.hasHour;
    }

    public getTime(): { hour: number, minute: number } {
        return this.time;
    }

    public getMetadata(): AnyObject {
        return this.metadata;
    }

    public getNutritionalProperties(): INutritionalProperties {
        return this.nutritionalProperties;
    }

    public getEditMode(): boolean {
        return this.editMode;
    }

    public getModeReadOnly(): boolean {
        return this.modeReadOnly;
    }

    public getValid(): boolean {
        return this.valid;
    }

    public getHasError(): boolean {
        return this.hasError;
    }


    getRawValueBlockPeriods(): BlockPeriodDTO[] {
        const blockPeriods: BlockPeriodDTO[] = [];
        this.blockPeriods.forEach(((blockPeriod: BlockPeriodClass, index) => {
            blockPeriods.push({
                index,
                title: blockPeriod.title,
                type: blockPeriod.type,
                hasHour: blockPeriod.hasHour,
                time: blockPeriod.hasHour ? blockPeriod.time : undefined,
                foodGroupTitle: blockPeriod.foodGroupTitle,
                foodGroupId: blockPeriod.foodGroupId,
                text: blockPeriod.text,
                ingredients: this.formatIngredients(blockPeriod.ingredients),
                metadata: blockPeriod.metadata,
                mealTimeId: blockPeriod.mealPlanId
            });
        }));
        return blockPeriods;
    }

    formatIngredients(ingredientsFoodGroup: Partial<IFoodGroupIngredient>[]): IIngredient[] {
        const ingredients = [];
        ingredientsFoodGroup?.forEach((ingredient: Partial<IFoodGroupIngredient>) => {
            ingredients.push({
                _id: ingredient.ingredientId,
                measureUnitId: ingredient.measure?._id,
                units: ingredient.units,
                smae: {
                    portion: ingredient.nutritionalProperties?.portions ?? ingredient.smae?.portion
                },
                category: {
                    _id: ingredient.category._id,
                    name: ingredient.category.name
                }
            });
        });
        return ingredients;
    }

      isValid(): boolean {

          console.log(this.valid);
          
          this.valid = true;
          
          if (!this.title) {
          this.valid = false;
          return this.valid;
        }
    
        
        this.blockPeriods.forEach(block => {
            if (!block.isValid()) {
                this.valid = false;
                return this.valid;
            }
        })
       

    
        return this.valid;
      }
}